import DsLink, { LinkProps } from '@carvana/ds-link';
import React from 'react';
import titleCaseChildren from '|/components/carvana-ds/title-case-children';
import { useSlate } from '|/context/slate-context';

interface CvnaLinkProps extends LinkProps {
  disableSlateTitleCase?: boolean;
}

const Link: React.FC<CvnaLinkProps> = ({
  children,
  style,
  disableSlateTitleCase = false,
  ...rest
}) => {
  const { isSlateVehicle } = useSlate();
  // ds-link (v5) has no underline prop and standalone links aren't underlined by
  // the token; inline style reliably overrides it for the Slate underline treatment.
  return (
    <DsLink {...rest} style={isSlateVehicle ? { textDecoration: 'underline', ...style } : style}>
      {isSlateVehicle && !disableSlateTitleCase ? titleCaseChildren(children) : children}
    </DsLink>
  );
};

export default Link;
export type { LinkProps };
